export const bookingUrl = "https://www.booking.com/hotel/de/"
